import script from "./Home.vue?vue&type=script&setup=true&lang=js"
export * from "./Home.vue?vue&type=script&setup=true&lang=js"

import "./Home.vue?vue&type=style&index=0&id=6f99c058&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src193580822/src/blackstonefarmsapartments/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f99c058"]])

export default __exports__